import { Tooltip } from "@wix/design-system";
import cx from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../../../ricos-context/index.js";
import classes from "./ToolbarButton-scss.js";
const ToolbarButton = React.forwardRef(
  ({
    active,
    disabled,
    tooltip,
    onClick,
    dataHook,
    className,
    label,
    prefix: Prefix,
    suffix: Suffix,
    ariaLabel,
    ...props
  }, ref) => {
    const { isMobile } = useContext(RicosContext);
    const button = /* @__PURE__ */ React.createElement(
      "button",
      {
        ref,
        className: cx(classes.toolbarButton, className, {
          [classes.mobileToolbarButton]: isMobile,
          [classes.active]: active,
          [classes.disabled]: disabled
        }),
        style: resolvePadding(label, Prefix, Suffix),
        onClick: disabled ? void 0 : onClick,
        onMouseDown: (e) => e.preventDefault(),
        "data-hook": cx(dataHook, {
          disabled,
          active
        }),
        disabled,
        type: "button",
        "aria-label": ariaLabel ?? tooltip,
        ...props
      },
      Prefix && /* @__PURE__ */ React.createElement(Prefix, null),
      label && /* @__PURE__ */ React.createElement(React.Fragment, null, label),
      Suffix && /* @__PURE__ */ React.createElement(Suffix, null)
    );
    return tooltip ? /* @__PURE__ */ React.createElement(Tooltip, { key: tooltip, content: tooltip, size: "small", moveBy: { y: 8 } }, button) : button;
  }
);
const resolvePadding = (label, prefix, suffix) => {
  if (!label) {
    return { paddingInline: "3px" };
  }
  const paddingInlineStart = prefix ? "6px" : "12px";
  const paddingInlineEnd = suffix ? "6px" : "12px";
  return {
    paddingInlineStart,
    paddingInlineEnd
  };
};
var ToolbarButton_default = ToolbarButton;
export {
  ToolbarButton_default as default
};
//# sourceMappingURL=ToolbarButton.js.map
